import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldOffIcon } from 'lucide-react';
export const UnauthorizedPage = () => {
  return <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-3004">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-3005">
        <div className="flex justify-center" data-id="element-3006">
          <ShieldOffIcon className="h-16 w-16 text-red-500" data-id="element-3007" />
        </div>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900" data-id="element-3008">
          Access Denied
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600" data-id="element-3009">
          You don't have permission to access this page.
        </p>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-3010">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10" data-id="element-3011">
          <div className="text-center" data-id="element-3012">
            <p className="text-gray-700 mb-4" data-id="element-3013">
              Please contact an administrator if you believe this is an error.
            </p>
            <div className="flex flex-col space-y-4" data-id="element-3014">
              <Link to="/login" className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-3015">
                Return to Login
              </Link>
              <Link to="/" className="w-full flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-3016">
                Go to Homepage
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>;
};